import useSWRImmutable from 'swr/immutable'
import { AxiosError } from 'axios'
import { AxiosBackend } from '../../service/HTTP/AxiosInstance'
import { SubscriptionOffer } from './interfaces'
import { subscriptionOfferSchema } from './subscriptionOfferSchema'

interface UseSubscriptionOffers {
  subscriptionOffers: SubscriptionOffer[]
  error: AxiosError
  isLoading: boolean
}

export const getSubscriptionsReq = () =>
  AxiosBackend.get<unknown>('/subscriptions')

export const useSubscriptionOffers = (): UseSubscriptionOffers => {
  const { data, error, isLoading } = useSWRImmutable(
    'subscriptions_offer_details',
    getSubscriptionsReq
  )

  const hookData = {
    subscriptionOffers: [],
    error,
    isLoading
  }

  if (isLoading || error) {
    return hookData
  }

  try {
    const response = subscriptionOfferSchema.parse(data?.data)

    return {
      ...hookData,
      subscriptionOffers: response as unknown as SubscriptionOffer[]
    }
  } catch {
    return {
      ...hookData,
      subscriptionOffers: []
    }
  }
}
